/**
 * @fileoverview Primitive default values.
 *
 * NOTE: Please don't import this file directly, but use the index file instead.
 */
export const DefaultUrl = "#no-such-anchor";
export const DefaultText = "…";
export const DefaultJSON = "{}";
